export enum VspPortalActions {

    SetArrivalLogsPageNumber = 'SetArrivalLogsPageNumber'
    , SetArrivalLogsPageSize = 'SetArrivalLogsPageSize'
    , SetArrivalLogsSorting = 'SetArrivalLogsSorting'
    , SetCardSwapSearchResultPageNumber = 'SetCardSwapSearchResultPageNumber'
    , SetCardSwapSearchResultPageSize = 'SetCardSwapSearchResultPageSize'
    , SetCardSwapSearchResultSorting = 'SetCardSwapSearchResultSorting'
    , SetCardSwapStatuses = 'SetCardSwapStatuses'
    , SetFunctionKey = 'SetFunctionKey'
    , SetIsDarkTheme = 'SetIsDarkTheme'
    , SetNotificationText = 'SetNotificationText'
    , SetNotificationType = 'SetNotificationType'
    , SetSchedule = 'SetSchedule'
    , SetUserGroups = 'SetUserGroups'
    , SetUserName = 'SetUserName'
    , SetVillage = 'SetVillage'
    , SetVillages = 'SetVillages'

};